import gql from 'graphql-tag';

export const SAFE_RESTART_SOLUTION_SERVER = gql`
    mutation {
        safeRestartSolutionServer
    }
`;